// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"b5971a3d","212":"42de6339","426":"c96c316d","496":"2c111ead","579":"5704ed25","625":"b48a5dd2","721":"bd61465d","729":"4438ccd9","787":"2c525f60","805":"a39882ea","943":"74fc4984","979":"770ae2bd"}[chunkId] + ".chunk.js";
};